/**
 * Created by cedricgodefroy on 17/08/2017.
 */
angular.module('FlexyBeautyApp.services')
    .factory('TypeOfSale', ['gettextCatalog', function (gettextCatalog) {

        var prestations = gettextCatalog.getString("Prestations"),
            produits = gettextCatalog.getString("Produits"),
            cures = gettextCatalog.getString("Cures"),
            loyalties = gettextCatalog.getString("Cartes de fidélité"),
            transformedBooking = gettextCatalog.getString("Réservation transformée"),
            unTransformedBooking = gettextCatalog.getString("Réservation non transformée"),
            all = gettextCatalog.getString("Tous");

        var typeOfSale = {
            SERVICE:                    {id: 'SERVICE',                 label: prestations},
            PRODUCT:                    {id: 'PRODUCT',                 label: produits},
            CURE:                       {id: 'CURE',                    label: cures},
            LOYALTY:                    {id: 'LOYALTY',                 label: loyalties},
            SERVICE_AND_PRODUCT:        {id: 'SERVICE_AND_PRODUCT',     label: transformedBooking},
            SERVICE_WITHOUT_PRODUCT:    {id: 'SERVICE_WITHOUT_PRODUCT', label: unTransformedBooking},
        };
        typeOfSale.ALL = {
            id: 'ALL',
            label: all,
            getSubStatCategories : function(rootCategory){ return [typeOfSale.SERVICE, typeOfSale.PRODUCT, typeOfSale.CURE, typeOfSale.LOYALTY]}
        };
        typeOfSale.ALL_WITH_PRODUCT_OR_NOT = {
            id: 'ALL_WITH_PRODUCT_OR_NOT',
            label: all,
            getSubStatCategories : function(rootCategory){ return [typeOfSale.SERVICE_AND_PRODUCT/*, typeOfSale.SERVICE_WITHOUT_PRODUCT*/]}
        }
        typeOfSale.values = function () {
            return [this.SERVICE, this.PRODUCT, this.CURE, this.LOYALTY]
        };

        return typeOfSale;
    }])
    .factory('TypeOfGraph', ["$filter",'gettextCatalog', function ($filter, gettextCatalog) {
        var tableau = gettextCatalog.getString("Tableau"),
            circulaire = gettextCatalog.getString("Diagramme circulaire"),
            colonne = gettextCatalog.getString("Diagramme en colonne"),
            colonnesempilees = gettextCatalog.getString("Diagramme en colonnes empilées"),
            batons = gettextCatalog.getString("Diagramme en batons"),
            batonsEmpiles = gettextCatalog.getString("Diagramme en batons empilés");
        var representations = {
            TABLE                   :{id : 'table',                 label : tableau,                            icon: 'fa-table'},
            PIECHART                :{id : 'pie-chart',             label : circulaire,                         icon: 'fa-pie-chart'},
            COLUMNCHART             :{id : 'column-chart',          label : colonne,                            icon: 'fa-bar-chart'},
            STACKEDCOLUMNCHART      :{id : 'stacked-column-chart',  label : colonnesempilees,                   icon: 'fa-bar-chart'},
            BARCHART                :{id : 'bar-chart',             label : batons,                             icon: 'fa-bar-chart'},
            STACKEDBARCHART         :{id : 'stacked-bar-chart',     label : batonsEmpiles,                      icon: 'fa-bar-chart'}
        };
        representations.getAll = function() {
            return [this.TABLE, this.PIECHART, this.COLUMNCHART, this.STACKEDCOLUMNCHART, this.BARCHART, this.STACKEDBARCHART]
        };
        representations.getStacked = function() {
            return [this.TABLE, this.STACKEDCOLUMNCHART, this.STACKEDBARCHART]
        };
        representations.getTypeGraphById = function(id){
            return $filter('filter')(this.getAll(), function(elt){
                return (elt.id === id);
            })[0];
        };
        return representations;
    }])
    .factory('EltReportType', ["$filter", function ($filter) {
        var eltReportType = {
            TOTALISE                    :{id: 'TOTALISE'},
            COMPARE                     :{id: 'COMPARE'},
            ZOOM                        :{id: 'ZOOM'},
        };
        eltReportType.getAll = function() {
            return [this.TOTALISE, this.COMPARE, this.ZOOM]
        };
        eltReportType.getEltReportTypeById = function(id){
            return $filter('filter')(this.getAll(), function(elt){
                return (elt.id === id);
            })[0];
        };
        return eltReportType;
    }])
    .factory('ReportTotalAgregateFunctionType', [function () {
        var reportTotalAgregateFunctionType = {
            SUM_CATEGORIES                    :{id: 'SUM_CATEGORIES'},
            AVERAGE_CATEGORIES                :{id: 'AVERAGE_CATEGORIES'},
            NO_AGREGATION                     :{id: 'NO_AGREGATION'}
        };

        return reportTotalAgregateFunctionType;
    }])
    .factory('ReportTemporalAgregateFunctionType', [function () {
        var reportTemporalAgregateFunctionType = {
            DAILY_SUM                    :{id: 'DAILY_SUM'},
            DAILY_AVERAGE                :{id: 'DAILY_AVERAGE'}
        };

        return reportTemporalAgregateFunctionType;
    }])
    .factory('DataType', [function () {
        var dataType = {
            NB                      :{id: 'NB'},
            VALUE                   :{id: 'VALUE'}
        };
        return dataType;
    }])
    .factory('ColorGraph', [function () {
        var colorGraph = {
            colors : ['#bfe9ff','#e5d1ff', '#b4ffc7', '#f6f460', '#ffe0f0','#ffd6a6','#ffcac7','#ddd3ff','#7cd9ff','#c5ff6c'],
        };
        return colorGraph;
    }])
    .factory('PrimaryDatasType',["SaleService","Sale","SaleProduct","SaleCure","LoyaltyCardItem","Booking","GiftItem","Customer","BookingService","HrOccupationDatas",
        function(SaleService,Sale, SaleProduct,SaleCure,LoyaltyCardItem,Booking,GiftItem,Customer,BookingService,HrOccupationDatas){
        var primaryDatasType = {
            SALESERVICE             :{id : 'SALESERVICE',       fileLabel:'ventes-prestatiions'         },
            SALEPRODUCT             :{id : 'SALEPRODUCT',       fileLabel:'ventes-produits'             },
            SALECURE                :{id : 'SALECURE',          fileLabel:'ventes-cures'                },
            LOYALTYCARDITEM         :{id : 'LOYALTYCARDITEM',   fileLabel:'ventes-cartes-fidelite'      },
            SALE                    :{id : 'SALE',              fileLabel:'ventes'                      },
            BOOKING                 :{id : 'BOOKING',           fileLabel:'reservations'                },
            GIFTITEM                :{id : 'GIFTITEM',          fileLabel:'cheques-cadeaux'             },
            CUSTOMER                :{id : 'CUSTOMER',          fileLabel:'clients'                     },
            BOOKINGSERVICE          :{id : 'BOOKINGSERVICE',    fileLabel:'reservations-prestations'    },
            HROCCUPATIONDATAS       :{id : 'HROCCUPATIONDATAS', fileLabel:'occupation-personnel'        },
            VISITE                  :{id : 'VISITE',            fieldLabel:'visites'}
        };
        primaryDatasType.getType = function (objectModel) {
            if (!objectModel)
                return null;

            if (objectModel instanceof SaleService) {
                return this.SALESERVICE;
            }
            else if (objectModel instanceof SaleProduct) {
                return this.SALEPRODUCT;
            }
            else if (objectModel instanceof SaleCure) {
                return this.SALECURE;
            }
            else if (objectModel instanceof LoyaltyCardItem) {
                return this.LOYALTYCARDITEM;
            }
            else if (objectModel instanceof Sale) {
                return this.SALE;
            }
            else if (objectModel instanceof Booking) {
                return this.BOOKING;
            }
            else if (objectModel instanceof GiftItem) {
                return this.GIFTITEM;
            }
            else if (objectModel instanceof Customer) {
                return this.CUSTOMER;
            }
            else if (objectModel instanceof BookingService) {
                return this.BOOKINGSERVICE;
            }
            else if (objectModel instanceof HrOccupationDatas) {
                return this.HROCCUPATIONDATAS;
            }
            else if (objectModel && objectModel.dataType && objectModel.dataType == "VISITE") {
                return this.VISITE;
            }
        }

        return primaryDatasType;
    }])
    .factory('RootStatCategorie', ["CategoryData", "ProductCategoryData", "CureCategoryData", "LoyaltyCardCategoryData", function (CategoryData, ProductCategoryData, CureCategoryData, LoyaltyCardCategoryData) {
        var rootStatCategorie = function() {
            this.id = "superCategory",
            this.label = "superCategory",
            this.getSubStatCategories = function (rootCategory) {
                return [CategoryData.categoryRoot, ProductCategoryData.categoryRoot, CureCategoryData.categoryRoot, LoyaltyCardCategoryData.categoryRoot]
            }
        };
        return new rootStatCategorie();
    }])
    .factory('ProductStatCategorie', ["gettextCatalog", "ProductCategoryData", function (gettextCatalog, ProductCategoryData) {
        var productStatCategorie = {
            ALL:    {
                id: 'PRODUCTS',
                label: "PRODUCTS",
                getSubStatCategories: function (rootCategory) {return [ProductCategoryData.categoryRoot]}
            },
        };

        return productStatCategorie;
    }])
    .factory('HrRootOccupationRateCategory', ['HumanResourceData', function (HumanResourceData) {
        var rootStatCategorie = {
            id: "HrRootOccupationRateCategory",
            label: "HrRootOccupationRateCategory",
            getSubStatCategories: function (rootCategory, periodDays) {
                var humanResourceList = HumanResourceData.getActiveList(),
                    humanResourceFinalList = humanResourceList;

                if(periodDays) {
                    humanResourceFinalList = new Array();
                    for (var i = 0; i < humanResourceList.length; i++) {
                        if (humanResourceList[i].statFilter(periodDays)) {
                            humanResourceFinalList.push(humanResourceList[i]);
                        }
                    }
                }
                return humanResourceFinalList;
            }
        };
        return rootStatCategorie;
    }])
    .factory('PrRootOccupationRateCategory', ['PhysicalResourceData', function (PhysicalResourceData) {
        var rootStatCategorie = {
            id: "PrRootOccupationRateCategory",
            label: "PrRootOccupationRateCategory",
            getSubStatCategories: function (rootCategory) {
                return PhysicalResourceData.getActiveList()
            }
        };
        return rootStatCategorie;
    }])
    .factory('PeriodType', ["$filter", "gettextCatalog", function ($filter, gettextCatalog) {
        var dayly = gettextCatalog.getString("Période quotidienne"),
            weekly = gettextCatalog.getString("Période hebdomadaire"),
            monthly = gettextCatalog.getString("Période mensuelle"),
            yearly = gettextCatalog.getString("Période annuelle"),
            defined = gettextCatalog.getString("Période définie");

        var periodType = {
            DAY:        {id: 'DAY',         label: 'jour',      selecLabel : dayly},
            WEEK:       {id: 'WEEK',        label: 'semaine',   selecLabel : weekly},
            MONTH:      {id: 'MONTH',       label: 'mois',      selecLabel : monthly},
            YEAR:       {id: 'YEAR',        label: 'annuel',    selecLabel : yearly},
            CUSTOMED:   {id: 'CUSTOMED',    label: 'customed',  selecLabel : defined},
        };
        periodType.getAll = function() {
            var tabPeriodType = new Array();
            for (var i in periodType) {
                if (periodType.hasOwnProperty(i)) {
                    tabPeriodType.push(periodType[i]);
                }
            }
            return tabPeriodType;
        };
        periodType.getPeriodTypeByLabel = function(label){
            return $filter('filter')(this.getAll(), function(elt){
                return (elt.label === label);
            })[0];
        };

        periodType.getLastDayOfPeriod = function (periodTypeObject, beginDayOfPeriod, nbDay) {
            var currentMomentDay = beginDayOfPeriod.clone(),
                endMomentDay = null;

            if(periodTypeObject  === this.DAY){
                endMomentDay = currentMomentDay.clone().add(1, 'day');
            }
            else if(periodTypeObject === this.WEEK){
                endMomentDay = currentMomentDay.clone().add(1, 'week');
            }
            else if(periodTypeObject === this.MONTH){
                endMomentDay = currentMomentDay.clone().add(1, 'month');
            }
            else if(periodTypeObject === this.YEAR){
                endMomentDay = currentMomentDay.clone().add(1, 'year');
            }
            else if(periodTypeObject === this.CUSTOMED){
                endMomentDay = currentMomentDay.clone().add(nbDay, 'day');
            }
            endMomentDay.add(-1, 'day');

            return endMomentDay;
        }

        return periodType;
    }])
    .factory('SchedulerType', ["$filter", "gettextCatalog", function ($filter, gettextCatalog) {
        var single = gettextCatalog.getString("Manuel"),
            dayly = gettextCatalog.getString("Journalier"),
            weekly = gettextCatalog.getString("Hebdomadaire"),
            monthly = gettextCatalog.getString("Mensuel"),
            yearly = gettextCatalog.getString("Annuel");

        var schedulerType = {
            SINGLE:       {id: 'single',        label: single},
            DAILY:        {id: 'daily',         label: dayly},
            WEEKLY:       {id: 'weekly',        label: weekly},
            MONTHLY:      {id: 'monthly',       label: monthly},
            YEARLY:       {id: 'yearly',        label: yearly}
        };
        schedulerType.getAll = function() {
            var tabShedulerType = new Array();
            for (var i in schedulerType) {
                if (schedulerType.hasOwnProperty(i)) {
                    tabShedulerType.push(schedulerType[i]);
                }
            }
            return tabShedulerType;
        };
        schedulerType.getSchedulerTypeByLabel = function(label){
            return $filter('filter')(this.getAll(), function(elt){
                return (elt.label === label);
            })[0];
        };

        schedulerType.getSchedulerTypeById = function(id){
            return $filter('filter')(this.getAll(), function(elt){
                return (elt.id === id);
            })[0];
        };

        return schedulerType;
    }])
    .factory('StatPeriodType', ["$filter","gettextCatalog", function ($filter,gettextCatalog) {
        var present = gettextCatalog.getString("present"),
            passed = gettextCatalog.getString("passée");

        var statPeriodType = {
            CURRENT:            {id: 'CURRENT',     label: present},
            PAST:               {id: 'PAST',        label: passed}
        };
        statPeriodType.getAll = function() {
            var tabStatPeriodType = new Array();
            for (var i in statPeriodType) {
                if (statPeriodType.hasOwnProperty(i)) {
                    tabStatPeriodType.push(statPeriodType[i]);
                }
            }
            return tabStatPeriodType;
        };
        statPeriodType.getPeriodTypeByLabel = function(label){
            return $filter('filter')(this.getAll(), function(elt){
                return (elt.label === label);
            })[0];
        };
        return statPeriodType;
    }])
    .factory('LoyaltyCustomers', ['HumanResourceData', "gettextCatalog", function (HumanResourceData, gettextCatalog) {
        var customersLabel = gettextCatalog.getString("Clients venus plusieurs fois"),
            newCustomersLabel = gettextCatalog.getString("Clients venus une seule fois");
        var LoyaltyCustomers = {
            id: "LoyaltyCustomers",
            label: "LoyaltyCustomers",
            noTitle:true,
            getSubStatCategories: function (rootCategory) {
                return HumanResourceData.getActiveList();
            }
        };
        return LoyaltyCustomers;
    }])
    .factory('HumanResourceExtra', ['CategoryData','ProductCategoryData','CureCategoryData','LoyaltyCardCategoryData', function (CategoryData,ProductCategoryData,CureCategoryData,LoyaltyCardCategoryData) {
        var HumanResourceExtra = {
            label : "Autre",
            getSubStatCategories : function(rootCategory){
                var subCategories = [CategoryData.categoryRoot, ProductCategoryData.categoryRoot, CureCategoryData.categoryRoot, LoyaltyCardCategoryData.categoryRoot];
                return subCategories;
            }
        };
        return HumanResourceExtra;
    }])
    .factory('HrRootCategory', ['HumanResourceData', 'HumanResourceExtra', function (HumanResourceData, HumanResourceExtra){
        var rootStatCategorie = {
            id: "hrRootCategory",
            label: "hrRootCategory",
            getSubStatCategories: function (rootCategory) {
                return HumanResourceData.getActiveList().concat([HumanResourceExtra]);
            }
        };
        return rootStatCategorie;
    }])
    .factory('GiftItemRootCategory', ["TypeOfBooking","gettextCatalog", function (TypeOfBooking, gettextCatalog) {
        var serviceLabel = gettextCatalog.getString("En prestation"),
            amountLabel = gettextCatalog.getString("En montant");
        var giftItemRootCategory = {
            id: "giftItemRootCategory",
            label: "giftItemRootCategory",
            subCategories : {
                SERVICE: {
                    id: "giftItemServiceCategory",
                    label: serviceLabel,
                    getSubStatCategories: function (rootCategory) {
                        return [TypeOfBooking.CREATE_BY_CUSTORMER, TypeOfBooking.NOT_CREATE_BY_CUSTOMER]
                    }
                },
                PRICE: {
                    id: "giftItemPriceCategory",
                    label: amountLabel,
                    getSubStatCategories: function (rootCategory) {
                        return [TypeOfBooking.CREATE_BY_CUSTORMER, TypeOfBooking.NOT_CREATE_BY_CUSTOMER]
                    }
                }
            },
            getSubStatCategories: function (rootCategory) {
                return [this.subCategories.SERVICE, this.subCategories.PRICE]
            }
        };

        return giftItemRootCategory;
    }])
    .factory('GiftItemByHrRootCategory', ["HumanResourceData", function (HumanResourceData) {
        var giftItemByHrRootCategory = {
            id: "giftItemByHrRootCategory",
            label: "giftItemByHrRootCategory",
            getSubStatCategories: function (rootCategory) {
                return HumanResourceData.getActiveList();
            }
        };
        return giftItemByHrRootCategory;
    }])
    .factory('NbCustormerCategoryStat', ["gettextCatalog", function (gettextCatalog) {
        var mens = gettextCatalog.getString("Hommes"),
            womens = gettextCatalog.getString("Femmes"),
            children = gettextCatalog.getString("Enfants"),
            unknow = gettextCatalog.getString("Non précisé"),
            walkin = gettextCatalog.getString("Clients de passage");
        var nbCustormercategoryStat = {
            id: "NbCustormerCategoryStat",
            label: "NbCustormerCategoryStat",
            subCategories : {
                MEN_VISITS: {id: 'MEN_VISITS',              label: mens},
                WOMEN_VISITS: {id: 'WOMEN_VISITS',          label: womens},
                CHILDREN_VISITS: {id: 'CHILDREN_VISITS',    label: children},
                UNDEFINED_VISITS: {id: 'UNDEFINED_VISITS',  label: unknow},
                PASSENGER_VISITS: {id: 'PASSENGER_VISITS',  label: walkin}
            },
            getSubStatCategories: function (rootCategory) {
                return [this.subCategories.MEN_VISITS, this.subCategories.WOMEN_VISITS, this.subCategories.CHILDREN_VISITS, this.subCategories.UNDEFINED_VISITS, this.subCategories.PASSENGER_VISITS]
            }
        };
        return nbCustormercategoryStat;
    }])
    .factory('TypeOfBooking', ['TypeOfCustomer','gettextCatalog', 'Brand', function (TypeOfCustomer,gettextCatalog, Brand) {
        let come = gettextCatalog.getString("Venus"),
            notCome = gettextCatalog.getString("Pas venus"),
            bookedInline = gettextCatalog.getString("Réservé en ligne"),
            bookedOnSite = gettextCatalog.getString("Réservé sur site"),
            comeNotCome = gettextCatalog.getString("Venus/Pas venu"),
            inlineOnSite = gettextCatalog.getString("Réservé en ligne/sur site"),
            createByRGW = gettextCatalog.getString("Réservé depuis Google"),
            createByWebSite = gettextCatalog.getString("Réservé depuis {{brandLabel}}", {brandLabel: Brand.label});

        let typeOfBooking = {
            COME:                               {id: 'COME',                        label: come},
            NOT_COME:                           {id: 'NOT_COME',                    label: notCome},
            CREATE_BY_CUSTORMER:                {id: 'CREATE_BY_CUSTORMER',         label: bookedInline},
            NOT_CREATE_BY_CUSTOMER:             {id: 'NOT_CREATE_BY_CUSTOMER',      label: bookedOnSite},
            COME_AND_NOT_COME:                  {id: 'COME_AND_NOT_COME',           label: comeNotCome},
            CREATE_BY_CUSTORMER_AND_NOT:        {id: 'CREATE_BY_CUSTORMER_AND_NOT', label: inlineOnSite},
            CREATE_BY_RWG:                      {id: 'CREATE_BY_RWG',               label: createByRGW},
            CREATE_BY_WEBSITE:                  {id: 'CREATE_BY_WEBSITE',           label: createByWebSite}
        };
        typeOfBooking.COME_AND_NOT_COME.getSubStatCategories = function(){ return [typeOfBooking.COME, typeOfBooking.NOT_COME]};
        typeOfBooking.COME.getSubStatCategories = function(){ return [TypeOfCustomer.OLD_CUSTOMER, TypeOfCustomer.NEW_CUSTOMER]};
        typeOfBooking.NOT_COME.getSubStatCategories = function(){ return [TypeOfCustomer.OLD_CUSTOMER, TypeOfCustomer.NEW_CUSTOMER]};
        typeOfBooking.CREATE_BY_CUSTORMER_AND_NOT.getSubStatCategories = function(){ return [typeOfBooking.CREATE_BY_CUSTORMER, typeOfBooking.NOT_CREATE_BY_CUSTOMER]};
        typeOfBooking.CREATE_BY_CUSTORMER.getSubStatCategories = function(){ return [typeOfBooking.CREATE_BY_RWG, typeOfBooking.CREATE_BY_WEBSITE]};

        return typeOfBooking;
    }])
    .factory('TypeOfCustomerRootCategory', ['TypeOfCustomer', function (TypeOfCustomer) {
        var typeOfCustomerRootCategory = {
            id: "TypeOfCustomerRootCategory",
            label: "TypeOfCustomerRootCategory",
            getSubStatCategories: function () {
                return [TypeOfCustomer.OLD_CUSTOMER, TypeOfCustomer.NEW_CUSTOMER];
            }
        };
        return typeOfCustomerRootCategory;
    }])
    .factory('TypeOfCustomer', ['gettextCatalog', function (gettextCatalog) {
        var oldCustoms = gettextCatalog.getString("Anciens clients"),
            newCusoms = gettextCatalog.getString("Nouveaux clients");
        var typeOfCustomer = {
            OLD_CUSTOMER:                       {id: 'OLD_CUSTOMER',            label: oldCustoms},
            NEW_CUSTOMER:                       {id: 'NEW_CUSTOMER',            label: newCusoms}
        };
        return typeOfCustomer;
    }])
    .factory('WorkingTimeRootCategory', ['HumanResourceData', function (HumanResourceData) {
        var rootStatCategorie = {
            id: "WorkingTimeRootCategory",
            label: "WorkingTimeRootCategory",
            getSubStatCategories: function (rootCategory, periodDays) {
                var humanResourceList = HumanResourceData.getActiveList(),
                    humanResourceFinalList = humanResourceList;

                if(periodDays) {
                    humanResourceFinalList = new Array();
                    for (var i = 0; i < humanResourceList.length; i++) {
                        if (humanResourceList[i].statFilter(periodDays)) {
                            humanResourceFinalList.push(humanResourceList[i]);
                        }
                    }
                }
                return humanResourceFinalList;
            }
        };
        return rootStatCategorie;
    }])
    .factory('WorkingTimeHrIndisponibilityTime', ['WorkingTimeHrUsualIndisponibilityTime','WorkingTimeHrUnusualIndisponibilityTime', function (WorkingTimeHrUsualIndisponibilityTime,WorkingTimeHrUnusualIndisponibilityTime) {
        var rootStatCategorie = {
            id: "WorkingTimeHrIndisponibilityTime",
            label: "Période d'indisponibilité",
            getSubStatCategories: function (rootCategory, periodDays) {
                return [WorkingTimeHrUsualIndisponibilityTime,WorkingTimeHrUnusualIndisponibilityTime]
            }
        };
        return rootStatCategorie;
    }])
    .factory('WorkingTimeHrUsualIndisponibilityTime', ['HumanResourceData', function (HumanResourceData) {
        var rootStatCategorie = {
            id: "WorkingTimeHrUsualIndisponibilityTime",
            label: "Indisponibilité réccurentes",
        };
        return rootStatCategorie;
    }])
    .factory('WorkingTimeHrUnusualIndisponibilityTime', ['HumanResourceData', function (WorkingTimeHrUnusualIndisponibilityTime) {
        var rootStatCategorie = {
            id: "WorkingTimeHrUnusualIndisponibilityTime",
            label: "Indisponibilités exceptionnelles",
        };
        return rootStatCategorie;
    }])
    .factory('WorkingTimeHrBookingOpenTime', ['WorkingTimeHrUnoccupiedTime','WorkingTimeHrBookingTime', function (WorkingTimeHrUnoccupiedTime,WorkingTimeHrBookingTime) {
        var rootStatCategorie = {
            id: "WorkingTimeHrBookingOpenTime",
            label: "Période ouverte aux prestations",
            getSubStatCategories: function (rootCategory, periodDays) {
                return [WorkingTimeHrUnoccupiedTime,WorkingTimeHrBookingTime];
            }
        };
        return rootStatCategorie;
    }])
    .factory('WorkingTimeHrUnoccupiedTime', ['HumanResourceData', function (HumanResourceData) {
        var rootStatCategorie = {
            id: "WorkingTimeHrUnoccupiedTime",
            label: "Innoccupé",
        };
        return rootStatCategorie;
    }])
    .factory('WorkingTimeHrBookingTime', ['HumanResourceData', function (HumanResourceData) {
        var rootStatCategorie = {
            id: "WorkingTimeHrBookingTime",
            label: "En prestation",
        };
        return rootStatCategorie;
    }])
    .factory('HrOccupationDatas', [function () {
         var HrOccupationDatas = function(day, unoccupiedTime, bookingTime, unusualIndisponibilityTime, usualIndisponibilityTime){
            this.day = day;
            this.unoccupiedTime = unoccupiedTime;
            this.bookingTime = bookingTime;
            this.unusualIndisponibilityTime = unusualIndisponibilityTime;
            this.usualIndisponibilityTime = usualIndisponibilityTime;
        }
        return HrOccupationDatas;
    }])


// WEBPACK FOOTER //
// ./js/services/views/statistics/report/ConstantsStat.js